import { useState } from 'react'
import { EditorContent, textToEditorContent } from 'components/CommonComponents/RichTextEditor'

interface IUsePostTextContent {
  postTitle?: string
  postRichText?: EditorContent | null
}
const isValidEditorContent = (v: any): v is EditorContent =>
  Boolean(v && typeof v === 'object' && !Array.isArray(v) && v.type === 'doc')

export const usePostTextContent = ({ postTitle, postRichText }: IUsePostTextContent) => {
  const validRichText = isValidEditorContent(postRichText) ? postRichText : null
  const [richTextValue, setRichTextValue] = useState<EditorContent | null>(
    validRichText ?? (postTitle ? textToEditorContent(postTitle) : null)
  )
  const [title, setTitle] = useState(postTitle ?? '')
  const [message, setMessage] = useState('')

  const clearTextContentState = () => {
    setRichTextValue(null)
    setTitle('')
    setMessage('')
  }

  return {
    richTextValue,
    setRichTextValue,
    title,
    setTitle,
    message,
    setMessage,
    clearTextContentState,
  }
}
